// based on the ISO 3166 list of Peru subdivisions: https://en.wikipedia.org/wiki/ISO_3166-2:PE
export const peruStateOptions = [
  { ID: "AMA", name: "Amazonas" },
  { ID: "ANC", name: "Ancash" },
  { ID: "APU", name: "Apurímac" },
  { ID: "ARE", name: "Arequipa" },
  { ID: "AYA", name: "Ayacucho" },
  { ID: "CAJ", name: "Cajamarca" },
  { ID: "CUS", name: "Cusco" },
  { ID: "CAL", name: "El Callao" },
  { ID: "HUV", name: "Huancavelica" },
  { ID: "HUC", name: "Huánuco" },
  { ID: "ICA", name: "Ica" },
  { ID: "JUN", name: "Junín" },
  { ID: "LAL", name: "La Libertad" },
  { ID: "LAM", name: "Lambayeque" },
  { ID: "LIM", name: "Lima" },
  { ID: "LOR", name: "Loreto" },
  { ID: "MDD", name: "Madre de Dios" },
  { ID: "MOQ", name: "Moquegua" },
  { ID: "LMA", name: "Municipalidad Metropolitana de Lima" },
  { ID: "PAS", name: "Pasco" },
  { ID: "PIU", name: "Piura" },
  { ID: "PUN", name: "Puno" },
  { ID: "SAM", name: "San Martín" },
  { ID: "TAC", name: "Tacna" },
  { ID: "TUM", name: "Tumbes" },
  { ID: "UCA", name: "Ucayali" },
];
